export default "__VITE_ASSET__DaX_flPl__"